import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import appContext from '../AppContext';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 9,
    maxWidth: 300
  },
}));

const stationAlias = 
{
    "Archives": "Archives-Navy Mem'l",
    "Benning Rd": "Benning Road",
    "Foggy Bottom": "Foggy Bottom-GWU",
    "Foggy Bottom/GWU": "Foggy Bottom-GWU",
    "Gallery Place": "Gallery Pl-Chinatown",
    "Georgia Ave-Petworth": "Georgia Ave Petworth",
    "Mt. Vernon Square/7th St-Convention Center": "Mt Vernon Sq - 7th St Convention Center",
    "Navy Yard-Ballpark": "Navy Yard - Ballpark",
    "NoMa-Gallaudet U": "NoMa - Gallaudet U",
    "NoMa-Gallaudet University": "NoMa - Gallaudet U",
    "Rhode Island Avenue-Brentwood": "Rhode Island Ave",
    "Shaw-Howard U": "Shaw-Howard Univ",
    "Shaw-Howard University": "Shaw-Howard Univ",
    "Stadium-Armory": "Stadium Armory",
    "Tenleytown": "Tenleytown-AU",
    "U Street": "U St/African-Amer Civil War Memorial/Cardozo",
    "Woodley Park-Zoo": "Woodley Park-Zoo Adams Morgan"
};
    
const outDCStationLines =
{
"Southern Ave": "green",
"Southern Avenue": "green",
"Capitol Heights": "blue, silver"
};
    

function Rail(props) {
    const {stations} = useContext(appContext);
    function getColor(line){
        let color = null;
        switch(line){
            case "green":
                color = "#008000";
                break;
            case "orange":
                color = "#FFA500"
                break;
            case "red":
                color = "#FF0000"
                break;
            case "yellow":
                color = "#ffff00"
                break;
            case "silver":
                color = "#C0C0C0";
                break;
            case "blue":
                color = "#0000FF"
                break;
            default:
                color = "#00000"
        }
        return color;
    }

    function getStationLines(stops){
        if (!stops){
            return [];
        }
        let stationLines = [];
        stops.split(',').forEach(element => {
            // console.log('rail stop:', element);
            let lines = stations[element.trim()];
            if (!lines) {
                lines = stations[stationAlias[element.trim()]];
            }
            if (!lines) {
                lines = outDCStationLines[element.trim()];
            }
            if(lines){
                lines.split(',').forEach(elm => {
                    stationLines.push({
                        stop: element.trim(),
                        line: elm.trim()
                    });
                });
            } else {
                // console.log("Cannot find lines, please check data for station:", element);
            }
        });
        let lineStations = {};
        stationLines.forEach(element => {
            if (lineStations[element.line]){
                lineStations[element.line] += ', ' + element.stop;
            } else {
                lineStations[element.line] = element.stop;
            }
        });
        let keys = Object.keys(lineStations);
        keys.sort();
        let lineStationsSorted = keys.map((x)=> { return {line: x, stop: lineStations[x] }} );
        return lineStationsSorted;
    }

    return (
        <div className="flex items-center mb-[30px]">
          <img className='w-[15px]' alt='Metro Rail' src='./icons/rail.png' />
          {
            getStationLines(props.stops).map((item, i) => {
                    return (
                        <LightTooltip placement="top" title={item.stop} key={i}>
                        <div role="tooltip"
                            className="w-[8px] h-[8px] border border-[#333] rounded-full ml-[4px]"
                            style={
                                {
                                    backgroundColor: getColor(item.line),
                                }
                            }>
                        </div>
                        </LightTooltip>

                    );
            })
        }
        </div>
      );
} 

export default Rail;
